let spinner = null;
let map;
const m = {
	setThisSpinner(_this) {
		spinner = _this;
	},
	getThisSpinner() {
		return spinner;
	},
	setThisMap(_this) {
		map = _this;
	},
	getThisMap() {
		return map;
	}
};

export { m };
